/* Lost & Found 2.0 section-home.js (H): <lf-rail> (booth-sign rail). */
(() => {
  'use strict';
  const define = (name, ctor) => { if (!customElements.get(name)) customElements.define(name, ctor); };
  const motion = () => !matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Native scroll-snap rail with Previous / Next buttons (WCAG 2.5.7 alternative to dragging). The buttons page by the
     number of fully visible items; at either end they become aria-disabled (not disabled) so focus is never lost. */
  define('lf-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.vp = this.querySelector('[data-rail-viewport]');
      this.nav = this.querySelector('[data-rail-nav]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      if (!this.vp || !this.prev || !this.next) return;
      this.bound = true;
      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      let ticking = false;
      this.onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; this.sync(); }); } };
      this.vp.addEventListener('scroll', this.onScroll, { passive: true });
      /* Keyboard: a sign that takes focus while partly outside the viewport scrolls fully into view (the snap rail
         does not do it by itself below 1024 px). */
      this.onFocusIn = (e) => {
        const item = e.target !== this.vp && e.target.closest && e.target.closest('[data-rail-item]');
        if (!item) return;
        const v = this.vp.getBoundingClientRect(), r = item.getBoundingClientRect();
        if (r.left < v.left - 1 || r.right > v.right + 1) item.scrollIntoView({ block: 'nearest', inline: 'start', behavior: motion() ? 'smooth' : 'auto' });
      };
      this.vp.addEventListener('focusin', this.onFocusIn);
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(() => this.sync()); this.ro.observe(this.vp); }
      this.sync();
    }
    disconnectedCallback() {
      if (!this.bound) return;
      this.bound = false;
      this.prev.removeEventListener('click', this.onPrev);
      this.next.removeEventListener('click', this.onNext);
      this.vp.removeEventListener('scroll', this.onScroll);
      this.vp.removeEventListener('focusin', this.onFocusIn);
      if (this.ro) this.ro.disconnect();
    }
    step() {
      const item = this.vp.querySelector('[data-rail-item]');
      if (!item) return this.vp.clientWidth;
      const track = item.parentElement;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const w = item.getBoundingClientRect().width + gap;
      const per = Math.max(1, Math.floor((this.vp.clientWidth + gap) / w));
      return per * w;
    }
    go(dir) {
      const btn = dir < 0 ? this.prev : this.next;
      if (btn.getAttribute('aria-disabled') === 'true') return;
      this.vp.scrollBy({ left: dir * this.step(), behavior: motion() ? 'smooth' : 'auto' });
    }
    sync() {
      const max = this.vp.scrollWidth - this.vp.clientWidth;
      const scrollable = max > 4;
      if (this.nav) this.nav.hidden = !scrollable;
      this.prev.setAttribute('aria-disabled', String(!scrollable || this.vp.scrollLeft < 4));
      this.next.setAttribute('aria-disabled', String(!scrollable || this.vp.scrollLeft > max - 4));
    }
  });
})();
